<script setup>
import { Navigation, Pagination, Zoom } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { defineProps, ref } from 'vue';
import { getImagePath, getLocalImagePath } from '@/common/utils/Util';
import store from '@/store';
import REPORT_REASON_MODAL from '@/components/common/modal/ReportReasonModal.vue';
import { modalList, show } from '@/common/utils/ModalState';

const props = defineProps(['data']);
const emits = defineEmits(['close']);

const { files, isShowReport, index } = props.data;
let reason = ref('');

const fnReport = () => {
  show(modalList.REPORT_REASON_MODAL, {
    file: files[0]
  });
  emits('close');
};
</script>

<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="detail-view-modal">
        <!-- Swiper -->
        <div class="swiper mySwiper">
          <Swiper
            :zoom="true"
            :initialSlide="index"
            :pagination="{ type: 'bullets', el: '.swiper-pagination' }"
            :modules="[Pagination, Navigation, Zoom]"
            :navigation="true"
          >
            <SwiperSlide v-for="(file, index) in files" :key="index">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="slide">
                    <div class="swiper-zoom-container">
                      <img :src="file?.storedFileName" alt="photo" v-if="file?.storedFileName.includes('/api/media/')"/>
                      <img :src="getImagePath(file?.storedFileName)" alt="photo" v-else />
                      <!--<img :src="getLocalImagePath(file?.storedFileName)" alt="photo" />-->
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <div class="swiper-button-close" @click.stop="$emit('close')"></div>
          </Swiper>
        </div>
        <div class="modal-btn" v-if="isShowReport">
          <div class="btn-wrap">
            <button class="btn border-gray medium" @click.stop="fnReport">신고하기</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.detail-view-modal .swiper {
  overflow: visible !important;
}
</style>
